<template>
  <div class="big">
    <div class="container">
      <div class="searchbox">
        <div class="item">
          <span>产生时间</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 240px; margin-left: 6px"
            @change="search"
          >
          </el-date-picker>
        </div>
        <div class="item">
          <span>类型</span>
          <el-select
            :value="use_type"
            value-key="type_name"
            placeholder="请选择"
            style="width: 180px; margin-left: 6px"
            @change="changeSelect"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.type_name"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981; margin-left: 6px"
            @click="search"
            >查询</el-button
          >
        </div>
        <div class="item">
          <span style="margin-right: 10px">积分余额为0</span>
          <el-radio-group v-model="is_zero">
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            label="积分产生时间"
            prop="create_time"
          ></el-table-column>
          <el-table-column label="类型" prop="title"> </el-table-column>
          <el-table-column label="产生积分" prop="integral"> </el-table-column>
          <el-table-column
            label="使用积分"
            prop="used_integral"
          ></el-table-column>
          <el-table-column
            label="失效积分"
            prop="expire_integral"
          ></el-table-column>
          <el-table-column
            label="积分余额"
            prop="use_integral"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="toDetail(scope.row.integral_id)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('923') : false
                "
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="padding-top: 20px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
    <!-- 变动详情 -->
    <el-dialog
      title="积分跟踪详情"
      :visible.sync="detailDia"
      width="540px"
      :close-on-click-modal="false"
    >
      <div class="content">
        <div class="content_box">
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in logList"
              :key="index"
              :icon="item.icon"
              :type="item.type"
              :color="item.color"
              :size="item.size"
              :timestamp="item.time"
            >
              <div>
                <span>{{ item.create_time }}</span>
                <span style="margin: 0 6px 0 30px">积分</span>
                <span>
                  <span v-if="item.integral > 0">+</span>
                  {{ item.integral }}</span
                >
              </div>
              <div class="bg_gray">
                <div>
                  <span
                    v-if="
                      item.log_type == 1 ||
                      item.log_type == 2 ||
                      item.log_type == 14 ||
                      item.log_type == 15 ||
                      item.log_type == 16 ||
                      item.log_type == 17 ||
                      item.log_type == 18 ||
                      item.log_type == 19 ||
                      item.log_type == 21
                    "
                  >
                    新增积分：
                  </span>
                  <span v-if="item.log_type == 3"> 扣除积分： </span>
                  <span v-if="item.log_type == 4"> 返还积分： </span>
                  <span
                    v-if="
                      item.log_type == 5 ||
                      item.log_type == 6 ||
                      item.log_type == 7
                    "
                  >
                    作废积分：
                  </span>
                  <span v-if="item.log_type == 8"> 新增积分： </span>
                  <span
                    v-if="
                      item.log_type == 9 ||
                      item.log_type == 10 ||
                      item.log_type == 13
                    "
                  >
                    新增积分：
                  </span>
                  <span v-if="item.log_type == 11"> 扣除积分： </span>
                  <span class="weight">
                    <!-- <span v-if="item.log_type==1">问诊赠送</span>
                    <span v-if="item.log_type==2">处方订单赠送</span>
                    <span v-if="item.log_type==3">消费扣除</span>
                    <span v-if="item.log_type==4">消费退款返还</span>
                    <span v-if="item.log_type==5">过期作废</span>
                    <span v-if="item.log_type==6">问诊退款作废</span>
                    <span v-if="item.log_type==7">处方订单退款作废</span> -->
                    {{ item.title }}
                  </span>
                </div>
                <div style="margin-top: 8px">
                  <div v-if="item.log_type == 8">
                    <span> 赠送时间： </span>
                    <span>
                      {{ item.create_time }}
                    </span>
                    <span>
                      {{ item.doctor_name }}
                    </span>
                  </div>
                  <div v-if="item.agree_time">
                    <span> 接诊时间： </span>
                    <span>
                      {{ item.agree_time }}
                    </span>
                    <span style="margin-left: 10px"> 医生： </span>
                    <span>
                      {{ item.doctor_name }}
                    </span>
                  </div>
                  <div v-if="item.pay_time || item.order_sn">
                    <span v-if="item.pay_time" style="margin-right: 10px">
                      <span> 支付时间： </span>
                      <span>
                        {{ item.pay_time }}
                      </span>
                    </span>

                    <span v-if="item.log_type == 9">
                      <span> 医生： </span>
                      <span>
                        {{ item.doctor_name }}
                      </span>
                    </span>

                    <span v-else>
                      <span> 订单号： </span>
                      <span>
                        {{ item.order_sn }}
                      </span>
                    </span>
                  </div>
                  <div v-if="item.log_type == 11">
                    <span> 兑换内容： </span>
                    <span> 优惠券 </span>
                  </div>
                  <div
                    v-if="
                      item.log_type == 14 ||
                      item.log_type == 15 ||
                      item.log_type == 16 ||
                      item.log_type == 17 ||
                      item.log_type == 18 ||
                      item.log_type == 19 ||
                      item.log_type == 20 ||
                      item.log_type == 21
                    "
                  >
                    <span>
                      {{
                        item.log_type == 14
                          ? "签到时间"
                          : item.log_type == 15
                          ? "签到时间"
                          : item.log_type == 16
                          ? "分享时间"
                          : item.log_type == 17
                          ? "分享时间"
                          : item.log_type == 18
                          ? "邀请绑定时间"
                          : item.log_type == 19
                          ? "评价时间"
                          : item.log_type == 20
                          ? "分享时间"
                          : "分享时间"
                      }}：
                    </span>
                    <span> {{ item.create_time }} </span>
                    <span>{{ item.business_name }}</span>
                  </div>
                </div>
              </div>
              <!-- {{ item.context }} -->
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import integralmanage from "../../../api/integralmanage";
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      date: [],
      use_type: {
        type: 0,
        type_name: "全部",
      },
      options: [],
      is_zero: 0,
      detailDia: false,
      logList: [],
    };
  },
  props: ["userId"],
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getOptions();
  },
  activated() {
    this.getList();
  },
  methods: {
    //  获取积分赠送类型 积分变动
    getOptions() {
      integralmanage.getIntegralType({ type: 2 }).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          data.list.unshift({
            type: 0,
            type_name: "全部",
          });
          this.options = data.list;
        }
      });
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        user_id: this.userId,
        use_type: this.use_type.type,
        title: this.use_type.type_name,
        is_zero: this.is_zero,
      };
      if (this.date && this.date.length) {
        data.produce_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.produce_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/Integral/getUserIntegralUseList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm");
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //查看详情
    toDetail(integral_id) {
      this.axios
        .post("platform/Integral/getUserIntegralUseInfo", { integral_id })
        .then((res) => {
          if (res.code == 0) {
            this.logList = res.data.list.map((item) => {
              item.type = "primary";
              item.size = "large";
              item.create_time = dayjs
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm");
              item.agree_time = item.agree_time
                ? dayjs.unix(item.agree_time).format("YYYY-MM-DD HH:mm")
                : "";
              item.pay_time = item.pay_time
                ? dayjs.unix(item.pay_time).format("YYYY-MM-DD HH:mm")
                : "";
              return item;
            });
            this.detailDia = true;
          }
        });
    },
    //搜索
    changeSelect(e) {
      this.use_type = e;
      this.search();
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  align-items: center;
  box-sizing: border-box;
  .item {
    margin-right: 20px;
  }
}
.content {
  padding: 20px 20px 20px 0;
  text-align: left;
  .gray {
    color: #666;
    margin-right: 10px;
  }
  .title {
    display: inline-block;
    width: 98px;
  }
  .weight {
    font-weight: 700;
  }
  .green {
    color: #669961;
    font-size: 20px;
  }
  .content_box {
    margin-top: 5px;
  }
  .green_num {
    color: #669961;
    font-size: 20px;
    margin-left: 18px;
  }
}
.bg_gray {
  background: #f5f5f5;
  padding: 10px 8px;
  margin-top: 6px;
}
</style>
